<template>
  <div class="container-fluid">
    <div class="row body-row">
      <div class="col-md-3 col-lg-2 p-0 d-md-block bg-dark">
        <nav-main></nav-main>
      </div>
      <div class="col-md-9 ms-sm-auto col-lg-10 pt-3 ">
        <my-breadcrumb></my-breadcrumb>
        <div class="restaurants">
          <div class="row my-3">
            <h2 class="">{{ $t('companySettings.title') }}</h2>
          </div>
          <form @submit.prevent="updateCompany()">
            <div class="row">
              <div class="col-12 col-md-6 mb-3">
                <label for="companyName" class="form-label">{{ $t('companySettings.name') }}</label>
                <input v-model.trim="company.name" type="text" class="form-control" id="companyName">
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 mb-3 pt-2 d-block text-end">
                <button v-if="this.loader" type="button" class="btn btn-success" disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span>  {{ $t('companySettings.loading') }}</span>
                </button>
                <button v-else type="submit" class="btn btn-success">{{ $t('companySettings.save') }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import NavMain from './modules/NavMain'
import MyBreadcrumb from './modules/Breadcrumb'
const config = require('@/config')
import i18n from "@/i18n";
import axios from "axios";
export default {
  name: "Settings",
  components: {NavMain, MyBreadcrumb},
  data() {
    return {
      loader: false,
      company: {
        name: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'COMPANY',
    ])
  },
  methods: {
    async updateCompany() {
      await this.$store.dispatch('checkIdToken')
      this.loader = true
      let idToken = this.$store.state.tokens.idToken;
      let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
      const payload = JSON.stringify(this.company)
      axios.put(`${config.servUrl}admin/companies`, payload, axiosHeader)
          .then(response => {
            this.$store.dispatch('getCompanyInfo');
            this.loader = false
            this.$store.dispatch('addNewNotice', {text: i18n.global.t('companySettings.alerts.companySettingsSaved')})
          })
          .catch(error => {
            console.log(error);
            this.$store.dispatch('addNewNotice', {text: error, error: true})
            this.loader = false
          })
    }
  },
  watch: {
    'COMPANY'(e) {
      this.company.name = e.name
    },
  },
  mounted() {
    this.$store.dispatch('getCompanyInfo');
  }
}
</script>

<style scoped>

</style>
